import { message, Modal, Spin, Card, Flex, Table as TableAntd } from 'antd';
import { FieldArray, Formik } from 'formik';
import { FaPlus } from 'react-icons/fa';
import { Input } from 'formik-antd';
import React, { useEffect, useState } from 'react';
import { createStockWriteOffs, updateStockWriteOffs } from '~/services/hooks/stockWriteOffs';
import { useTranslation } from 'react-i18next';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import Row from '~/components/Row';
import { getItems } from '~/services/hooks/items';
import { useCheckAuth } from '~/components/Can/checkAuth';
import { Table } from '~/components/Table';
import { stockWriteOffItemsColumns } from '~/tables/stockWriteOffItems';
import Button from '~/components/Button';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  justification: null,
  stock_write_off_items: [],
};

export default function StockWriteOffsModal({ visible, onClose, stockWriteOffsEdit, isMobile }) {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const [loading, setLoading] = useState(false);
  const [fetchedItems, setFetchedItems] = useState([]);
  const [initialValues, setInitialValues] = useState(initial);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await getItems('', 'no-paginated');
      setFetchedItems(response);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleSave = async (values, { setErrors }) => {
    setLoading(true);
    try {
      values?.stock_write_off_items?.map((swoi) => {
        swoi.item_name = null;
      });

      if (values?.id) {
        await updateStockWriteOffs(values.id, values);
        message.success(t('atualizado com sucesso!'));
      } else {
        await createStockWriteOffs(values);
        message.success(t('criado com sucesso!'));
      }
      onClose();
    } catch (error) {
      console.error(error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (stockWriteOffsEdit) {
      return authCheck('@lowStock/edit');
    } else {
      return authCheck('@lowStock/create');
    }
  };

  useEffect(() => {
    if (visible) {
      if (stockWriteOffsEdit) {
        setInitialValues(stockWriteOffsEdit);
      }
      fetchItems();
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, errors }) => (
        <Modal
          title={stockWriteOffsEdit ? t('Editando baixa - ') + stockWriteOffsEdit.id : t('Criando baixa')}
          onCancel={onClose}
          style={{ maxWidth: isMobile ? '100%' : '1500px' }}
          afterClose={() => setInitialValues(initial)}
          open={visible}
          centered
          width={isMobile ? '100%' : '1200px'}
          footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} />}
        >
          <Spin spinning={loading}>
            <Card>
              <Row style={{ marginBottom: '10px' }}>
                <FormControl cols={{ xs: 24 }} field="justification" label={t('fields:stockWriteOffs.justification')}>
                  <Input.TextArea name="justification" rows={4} disabled={!fluidPermissions()} />
                </FormControl>
              </Row>
              <div style={{ marginBottom: '10px' }}>
                <i style={{ color: 'red', fontStyle: 'italic' }}>
                  Bebidas em vermelho são bebidas que foram excluídas do sistema
                </i>
              </div>
              <FieldArray name="stock_write_off_items">
                {({ push, remove }) => (
                  <Table
                    dataSource={values?.stock_write_off_items?.map((swoi, i) => ({
                      ...swoi,
                      key: i,
                      remove,
                    }))}
                    columns={stockWriteOffItemsColumns(fetchedItems, errors, fluidPermissions, setFieldValue)}
                    size="small"
                    rowClassName={() => 'editable-row'}
                    bordered
                    empty={false}
                    summary={() => {
                      return (
                        <TableAntd.Summary.Row>
                          <TableAntd.Summary.Cell>
                            <Flex style={{ height: '100%' }} align="flex-start" justify="center">
                              <Button
                                color="primary"
                                title="Adicionar item"
                                size="small"
                                onClick={() =>
                                  push({
                                    item_id: null,
                                    item_name: null,
                                    amount: null,
                                  })
                                }
                                style={{ width: '30px' }}
                                disabled={!fluidPermissions()}
                              >
                                <FaPlus />
                              </Button>
                            </Flex>
                          </TableAntd.Summary.Cell>
                          <TableAntd.Summary.Cell />
                          <TableAntd.Summary.Cell />
                        </TableAntd.Summary.Row>
                      );
                    }}
                  />
                )}
              </FieldArray>
            </Card>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
